<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="xl"
      :title="$t('workflow.processField.fields')"
    >
      <!-- {{ allFields }} -->
      <b-row>
        <b-col>
          <b-table
            hover
            :items="availableFields"
            :fields="tableFields"
            selectable
            select-mode="single"
            @row-selected="onSelectAvailable"
          >
          </b-table>
        </b-col>
        <b-col>
          <b-table
            hover
            :items="sortedSelectedFields"
            :fields="tableSelectedFields"
            selectable
            select-mode="single"
            @row-selected="onSelectAdded"
          >
          </b-table>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button class="ml-2" variant="green" @click="saveSelected()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
      <!-- {{ allFields }} -->
      <!-- {{ selectedFields }} -->
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "WorkflowAllFieldsModal",
  props: {
    processId: String,
    selectedFields: Array,
    selected: Array,
  },
  data() {
    return {
      allFields: [],
      tableFields: [
        {
          label: this.$t("geral.availableFields"),
          key: "fieldName",
          sortable: true,
        },
      ],
      tableSelectedFields: [
        {
          label: this.$t("geral.selectedFields"),
          key: "fieldName",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    availableFields() {
      let fields = [];
      let selectedFields = this.sortedSelectedFields;
      this.sortedAllFields.forEach((field) => {
        if (!selectedFields.some((e) => e.fieldName == field.fieldName)) {
          fields.push(field);
        }
      });
      return fields;
    },
    sortedAllFields() {
      let fields = [];
      this.allFields.forEach((field) => {
        if (field.active) {
          fields.push(field);
        }
      });
      return fields;
    },
    sortedSelectedFields() {
      let fields = [];
      this.selectedFields.forEach((field) => {
        if (field.active) fields.push(field);
      });
      return fields;
    },
  },
  methods: {
    show() {
      this.$refs.openModal.show();
      this.getAllFields();
    },
    getAllFields() {
      this.$apiWorkflow
        .get("/customFilter/allAvailableField/" + this.processId)
        .then((response) => {
          this.allFields = response.data;
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    saveSelected() {
      this.$apiWorkflow
        .post("/field/saveCustomFielter/" + this.processId, this.selectedFields)
        .then((response) => {
          this.$refs.openModal.hide();
          // this.$emit("update:selected", this.selectedFields);
          this.$emit("refreshFilter");
          this.$forceUpdate();
        });
    },
    onSelectAvailable(items) {
      for (let item of items) {
        this.selectedFields.push({
          active: true,
          fieldId: item.fieldId,
          fieldType: item.fieldType,
          fieldName: item.fieldName,
        });
      }
    },
    onSelectAdded(items) {
      for (let item of items) {
        this.selectedFields.forEach((selected) => {
          if (item.fieldName == selected.fieldName) selected.active = false;
        });
      }
    },
  },
};
</script>
